import { render, staticRenderFns } from "./MainTicketing.vue?vue&type=template&id=451b7920"
import script from "./MainTicketing.vue?vue&type=script&lang=ts"
export * from "./MainTicketing.vue?vue&type=script&lang=ts"
import style0 from "./MainTicketing.vue?vue&type=style&index=0&id=451b7920&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports